'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            currentCount: 0
        };
    },

    props: ['projectCount', 'projectText', 'projectText2'],
    methods: {
        incrementNumber: function incrementNumber() {
            var _this = this;

            var interval = setInterval(function () {
                if (_this.currentCount >= _this.projectCount) {
                    clearInterval(interval);
                    _this.currentCount = _this.projectCount;
                } else {
                    _this.currentCount += 14;
                }
            }, 30);
        }
    },
    ready: function ready() {
        this.incrementNumber();
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"about-projects\">\n    <div class=\"about-projects__text about-projects__text--1 title title--h3\">{{ projectText }}</div>\n    <div class=\"about-projects__count\">{{ currentCount }}</div>\n    <div class=\"about-projects__text about-projects__text--2 title title--h3\">{{ projectText2 }}</div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-92c5d5ce", module.exports)
  } else {
    hotAPI.update("_v-92c5d5ce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}